// Centralized configurable links & content placeholders
export const LOGO = "https://customer-assets-cm19k8pv.emergentagent.net/job_fitmama-fit/artifacts/nhoxw5nc_2ED0507D-64FA-475F-B844-01738C99ADB8.png";

export const LINKS = {
    calendly: "https://calendly.com/amanda-morani/consulenza",
    whatsapp: "https://wa.me/message/ACAS3F5UYQRCD1",
    whatsappPurchase: (program) =>
        `https://wa.me/message/ACAS3F5UYQRCD1?text=${encodeURIComponent(
            `Ciao Amanda! Vorrei acquistare il programma "${program}"`
        )}`,
    whatsappStart: `https://wa.me/message/ACAS3F5UYQRCD1?text=${encodeURIComponent(
        "Ciao Amanda! Sono pronto/a a iniziare 💪"
    )}`,
    instagram: "https://www.instagram.com/_coach_amy_?igsh=MWgzM2cwNzk4cHAydQ%3D%3D&utm_source=qr",
    email: "mailto:Amanda.morani@hotmail.com",
};

export const IMG = {
    hero: "https://images.unsplash.com/photo-1517838277536-f5f99be501cd?crop=entropy&cs=srgb&fm=jpg&w=1920&q=90",
    about: "https://images.pexels.com/photos/703012/pexels-photo-703012.jpeg?auto=compress&cs=tinysrgb&w=1200",
    aboutPregnancy: "https://images.unsplash.com/photo-1710897872810-363b7a8d3f95?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    servicePregnancy: "https://images.unsplash.com/photo-1710897872810-363b7a8d3f95?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    servicePostpartum: "https://images.pexels.com/photos/5310723/pexels-photo-5310723.jpeg?auto=compress&cs=tinysrgb&w=1200",
    servicePT: "https://images.pexels.com/photos/13106808/pexels-photo-13106808.jpeg?auto=compress&cs=tinysrgb&w=1200",
    pathFitness: "https://images.pexels.com/photos/2247179/pexels-photo-2247179.jpeg?auto=compress&cs=tinysrgb&w=1200",
    program1: "https://images.unsplash.com/photo-1518611012118-696072aa579a?crop=entropy&cs=srgb&fm=jpg&w=1000&q=85",
    program2: "https://images.unsplash.com/photo-1591258370814-01609b341790?crop=entropy&cs=srgb&fm=jpg&w=1000&q=85",
    program3: "https://images.unsplash.com/photo-1624013599822-1faf520c67d1?crop=entropy&cs=srgb&fm=jpg&w=1000&q=85",
    programBack: "https://images.unsplash.com/photo-1593431763017-c689a61b729a?crop=entropy&cs=srgb&fm=jpg&w=1000&q=85",
    testimonial1: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&w=400&q=85",
    testimonial2: "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&w=400&q=85",
};

export const PATHS = {
    "general-population": {
        slug: "general-population",
        label: "Forza & Benessere",
        kind: "image",
        image: IMG.pathFitness,
        tagline: "Personal training per tutti.",
        short: "Allenamento su misura per ogni obiettivo — forza, tono, benessere, postura.",
        intro: "Un percorso di personal training pensato per chiunque voglia rimettersi in forma, aumentare la forza, migliorare la postura o semplicemente sentirsi meglio nel proprio corpo.",
        highlight: "Allenamenti personalizzati, in presenza o online.",
        forWho: [
            "Chi vuole iniziare da zero",
            "Chi ha già esperienza e vuole andare oltre",
            "Chi si allena in palestra, a casa o all'aperto",
            "Chi cerca un programma su misura per i propri obiettivi",
        ],
    },
    "fitmama": {
        slug: "fitmama",
        label: "FitMama",
        kind: "logo",
        image: IMG.servicePregnancy,
        tagline: "Allenati in gravidanza in sicurezza.",
        short: "Il percorso specializzato per accompagnarti durante e dopo la gravidanza.",
        intro: "Il percorso dedicato alle future e neo mamme: allenamento sicuro e adattato a ogni trimestre della gravidanza e al recupero post parto.",
        highlight: "Allenati con metodo e programmi digitali dedicati.",
        forWho: [
            "Chi è in gravidanza e vuole allenarsi in sicurezza",
            "Chi è nel post parto e vuole recuperare",
            "Chi cerca un percorso specializzato e professionale",
        ],
    },
};

export const PROGRAMS = [
    {
        slug: "primo-trimestre",
        category: "gravidanza",
        num: "01",
        title: "Allenamento nel Primo Trimestre",
        desc: "Adattamento, respirazione, stabilità del core. Un programma pensato per iniziare in sicurezza.",
        img: IMG.program1,
        tagline: "Le fondamenta di una gravidanza attiva.",
        difficulty: "Principiante",
        duration: "8 settimane",
        frequency: "3 sessioni / settimana",
        level: "Adatto anche a chi parte da zero",
        intro: "Il primo trimestre è il momento in cui il tuo corpo cambia più di quanto tu possa vedere. Nausea, stanchezza, sbalzi d'umore: allenarsi bene ora significa costruire una base solida — senza forzare, imparando ad ascoltarti.",
        includes: [
            "Video-lezioni guidate passo-passo, spiegate con chiarezza",
            "Calendario settimanale con progressione graduale",
            "Focus su respirazione diaframmatica e attivazione del core profondo",
            "Esercizi di mobilità per contrastare nausea e tensioni",
            "Schede PDF scaricabili da consultare in ogni momento",
        ],
        benefits: [
            "Riduci stanchezza e sensazione di pesantezza",
            "Impari a respirare e connetterti al pavimento pelvico",
            "Costruisci forza e stabilità in totale sicurezza",
            "Prepari il corpo ai cambiamenti dei mesi successivi",
        ],
        forWho: "Per chi è all'inizio della gravidanza e vuole muoversi nel modo giusto fin da subito, anche senza esperienza sportiva precedente.",
    },
    {
        slug: "secondo-trimestre",
        category: "gravidanza",
        num: "02",
        title: "Allenamento nel Secondo Trimestre",
        desc: "Forza funzionale, mobilità dell'anca e prevenzione della lombalgia.",
        img: IMG.program2,
        tagline: "L'energia torna. Sfruttiamola bene.",
        difficulty: "Intermedio",
        duration: "8 settimane",
        frequency: "3-4 sessioni / settimana",
        level: "Ideale per chi ha già completato il primo trimestre attivo o per chi vuole iniziare a muoversi",
        intro: "Il secondo trimestre è spesso il periodo migliore: più energia, meno nausea. È il momento perfetto per lavorare sulla forza funzionale e prevenire i fastidi tipici che iniziano ad affacciarsi, come il mal di schiena.",
        includes: [
            "Programma di forza funzionale a corpo libero e con piccoli attrezzi",
            "Sequenze di mobilità dell'anca e del bacino",
            "Esercizi mirati alla prevenzione della lombalgia",
            "Calendario progressivo con settimane di scarico",
            "Schede PDF + video dimostrativi per ogni esercizio",
        ],
        benefits: [
            "Mantieni e sviluppi forza muscolare utile per il parto",
            "Previeni mal di schiena e dolori articolari",
            "Migliori postura ed equilibrio mentre la pancia cresce",
            "Aumenti resistenza ed energia quotidiana",
        ],
        forWho: "Per chi vuole approfittare della fase più energica della gravidanza per sentirsi forte, mobile e senza dolori.",
    },
    {
        slug: "terzo-trimestre",
        category: "gravidanza",
        num: "03",
        title: "Allenamento nel Terzo Trimestre",
        desc: "Preparazione al parto, respirazione consapevole, movimento a bassa intensità.",
        img: IMG.program3,
        tagline: "Preparati al grande giorno, con dolcezza.",
        difficulty: "Adattato / Dolce",
        duration: "6 settimane",
        frequency: "3 sessioni / settimana",
        level: "Movimento a bassa intensità, adatto alla pancia grande",
        intro: "Nel terzo trimestre il corpo si prepara al parto. L'allenamento diventa più dolce ma non meno importante: respirazione, mobilità del bacino e movimenti mirati ti accompagnano verso il momento più atteso con serenità e consapevolezza.",
        includes: [
            "Sequenze di respirazione consapevole per il travaglio",
            "Esercizi di mobilità del bacino e apertura dell'anca",
            "Movimento a bassa intensità sicuro fino a fine gravidanza",
            "Posizioni antalgiche per alleviare i fastidi finali",
            "Schede PDF + video con adattamenti per ogni settimana",
        ],
        benefits: [
            "Prepari corpo e respiro al travaglio e al parto",
            "Allevii tensioni a schiena, bacino e gambe",
            "Mantieni mobilità e circolazione nelle ultime settimane",
            "Arrivi al parto più serena e consapevole",
        ],
        forWho: "Per chi è nelle ultime settimane e desidera arrivare al parto in movimento, preparata e tranquilla.",
    },
    {
        slug: "post-parto-primi-3-mesi",
        category: "post-parto",
        num: "05",
        title: "Allenamento nei Primi 3 Mesi di Post Parto",
        desc: "Il rientro dolce: riconnessione con il corpo, respirazione e core profondo.",
        img: IMG.servicePostpartum,
        tagline: "Il ritorno al movimento, con dolcezza.",
        difficulty: "Dolce / Riabilitativo",
        duration: "8 settimane",
        frequency: "3 sessioni / settimana",
        level: "Adatto dai primi giorni dopo il via libera medico",
        intro: "I primi mesi dopo il parto sono delicati e preziosi. Questo percorso ti accompagna nel rientro al movimento in modo graduale e sicuro, riconnettendoti con il tuo corpo e ricostruendo le fondamenta prima di tornare a un'attività più intensa.",
        includes: [
            "Riattivazione della respirazione e del core profondo",
            "Esercizi per il recupero del pavimento pelvico",
            "Valutazione e lavoro dolce sulla diastasi addominale",
            "Progressione graduale settimana dopo settimana",
            "Schede ed esercizi da fare anche col neonato vicino",
        ],
        benefits: [
            "Recuperi la connessione con core e pavimento pelvico",
            "Riduci i sintomi della diastasi addominale",
            "Ricostruisci le basi in totale sicurezza",
            "Ritrovi energia e fiducia nel tuo corpo",
        ],
        forWho: "Per le neo mamme nei primi 3 mesi dopo il parto che vogliono ricominciare a muoversi in modo sicuro.",
    },
    {
        slug: "post-parto-4-6-mesi",
        category: "post-parto",
        num: "06",
        title: "Allenamento dai 4 ai 6 Mesi di Post Parto",
        desc: "Si torna a costruire: forza funzionale e stabilità per la vita da mamma.",
        img: IMG.program2,
        tagline: "Ricostruisci la tua forza.",
        difficulty: "Intermedio",
        duration: "8 settimane",
        frequency: "3-4 sessioni / settimana",
        level: "Per chi ha completato la fase di recupero iniziale",
        intro: "Con le fondamenta ricostruite, dai 4 ai 6 mesi è il momento di tornare a costruire forza e resistenza. Un programma che ti rende più forte per affrontare la quotidianità da mamma — sollevare, portare, muoverti senza dolori.",
        includes: [
            "Allenamento di forza funzionale progressivo",
            "Esercizi specifici per schiena e postura da mamma",
            "Lavoro continuativo su core e pavimento pelvico",
            "Progressione dei carichi settimana dopo settimana",
            "Schede ed esercizi adattabili a casa o in palestra",
        ],
        benefits: [
            "Torni a sentirti forte e capace",
            "Previeni dolori legati alla cura del neonato",
            "Migliori postura, stabilità ed energia",
            "Costruisci una base per tornare allo sport che ami",
        ],
        forWho: "Per le mamme dai 4 ai 6 mesi dopo il parto pronte a tornare a costruire forza.",
    },
    {
        slug: "post-parto-entro-anno",
        category: "post-parto",
        num: "07",
        title: "Allenamento Entro l'Anno dal Post Parto",
        desc: "Il ritorno alla performance: forza, energia e libertà di movimento.",
        img: IMG.servicePT,
        tagline: "Torna più forte di prima.",
        difficulty: "Intermedio / Avanzato",
        duration: "10 settimane",
        frequency: "3-4 sessioni / settimana",
        level: "Per chi ha una buona base e vuole tornare alla piena attività",
        intro: "Entro l'anno dal parto puoi tornare — e spesso superare — la forma di prima. Questo percorso ti riporta alla piena performance con un allenamento completo, sfidante e progressivo, pensato per la nuova te.",
        includes: [
            "Allenamento completo di forza e condizionamento",
            "Progressione verso carichi e intensità piene",
            "Reintegrazione di corsa/salti in sicurezza (se desiderata)",
            "Lavoro su performance, tono ed estetica",
            "Schede ed esercizi per casa o palestra",
        ],
        benefits: [
            "Torni alla piena forza e performance",
            "Riconquisti tono, energia e sicurezza",
            "Ti rimetti in gioco con lo sport che ami",
            "Chiudi il cerchio del percorso post parto",
        ],
        forWho: "Per le mamme entro l'anno dal parto che vogliono tornare al 100% della propria forma.",
    },
    {
        slug: "mal-di-schiena",
        category: "gravidanza",
        num: "04",
        title: "Mal di Schiena in Gravidanza",
        desc: "Come risolverlo in 6 settimane: un percorso mirato alle catene posteriori e al core profondo.",
        img: IMG.programBack,
        tagline: "Dì addio al mal di schiena, in 6 settimane.",
        difficulty: "Tutti i livelli",
        duration: "6 settimane",
        frequency: "3 sessioni / settimana",
        level: "Adatto in qualsiasi trimestre (con ok medico)",
        intro: "Il mal di schiena è uno dei fastidi più comuni — e più sottovalutati — della gravidanza. Questo percorso mirato ti dà gli strumenti per capirne le cause e ridurlo concretamente, settimana dopo settimana, con esercizi semplici ed efficaci.",
        includes: [
            "Percorso strutturato in 6 settimane progressive",
            "Esercizi mirati a core profondo e catene posteriori",
            "Routine antalgiche da fare anche in giornata",
            "Consigli posturali per la vita quotidiana",
            "Schede PDF + video dimostrativi passo-passo",
        ],
        benefits: [
            "Riduci concretamente il dolore lombare",
            "Rinforzi il core profondo che sostiene la schiena",
            "Migliori la postura compromessa dal peso della pancia",
            "Ritrovi libertà nei movimenti di ogni giorno",
        ],
        forWho: "Per ogni futura mamma che convive con mal di schiena o tensioni lombari e vuole finalmente stare meglio.",
    },
];

export const SERVICES = [
    { title: "Gravidanza", tag: "01 — Prenatal", category: "gravidanza", desc: "Un allenamento che si adatta ad ogni trimestre. Sicurezza, respirazione, forza funzionale.", img: IMG.servicePregnancy },
    { title: "Post parto", tag: "02 — Postnatal", category: "post-parto", desc: "Rieducazione posturale, riabilitazione della diastasi, ritorno all'attività.", img: IMG.servicePostpartum },
];

export const TESTIMONIALS = [
    { name: "Chiara M.", role: "Mamma di Sofia", category: "Gravidanza", quote: "Ho ritrovato energia e sicurezza. Un percorso che mi ha accompagnata dalla 12° settimana al post parto, sempre con professionalità." },
    { name: "Marco T.", role: "Personal Training 1:1", category: "Personal Training", quote: "In pochi mesi ho ritrovato forza e mobilità che pensavo di aver perso. Allenamenti mai banali, sempre calibrati su di me: Amanda sa esattamente cosa serve e quando." },
];
